import React from "react";

import warpLogo from "../assets/400px-x-140px.png";

const footerLinks = [
  { label: "Home", href: "https://warpspeedmortgage.com/" },
  { label: "About", href: "https://warpspeedmortgage.com/about/" },
  {
    label: "Learning Center",
    href: "https://warpspeedmortgage.com/learning-center/",
  },
  { label: "Contact", href: "https://warpspeedmortgage.com/contact/" },
  { label: "Privacy", href: "https://warpspeedmortgage.com/privacy/" },
  {
    label: "Licensing",
    href: "https://warpspeedmortgage.com/licensing/",
  },
  {
    label: "Terms of Use",
    href: "https://warpspeedmortgage.com/terms-of-use/",
  },
  {
    label: "Cookie Information & Opt-Out",
    href: "https://warpspeedmortgage.com/cookie-information-opt-out/",
  },
  {
    label: "Make a Mortgage Payment",
    href: "https://secure2.cpteller.com/portal/?op=RxAluX10MCkX",
    external: true,
  },
  {
    label: "Reverse Mortgage Disclosures",
    href: "https://warpspeedmortgage.com/reverse-mortgage-disclosures/",
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bottom-0 z-10 overflow-hidden bg-[#343434] text-white">
      <div className="h-6 w-full bg-gradient-to-r from-[#4e9cd1] via-[#3d86bc] to-[#5aa7d9]" />

      <div className="mx-auto max-w-7xl px-6 py-10 md:px-10 lg:px-12 lg:py-12">
        <div className="flex flex-col gap-10 lg:flex-row lg:gap-16">
          <div className="flex w-full flex-col items-center lg:w-[15rem] lg:items-start">
            <a href="https://warpspeedmortgage.com/" className="inline-flex max-w-[190px] items-center">
              <img
                src="https://warpspeedmortgage.com/wp-content/uploads/2021/03/400px-x-140px-300x79.png"
                alt="Warp Speed Mortgage"
                className="w-full object-contain"
              />
            </a>

            <div className="mt-8 flex items-center gap-4 text-sm font-semibold uppercase tracking-[0.28em] text-blue-50">
              <a
                href="https://warpspeedmortgage.com/wp-content/uploads/2021/03/ehl@2x-293x300.png"
                target="_blank"
                rel="noreferrer"
                className="flex h-14 w-14 items-center justify-center  p-2"
                aria-label="Equal Housing Lender logo"
              >
                <img
                  src="https://warpspeedmortgage.com/wp-content/uploads/2021/03/ehl@2x-293x300.png"
                  alt="Equal Housing Lender"
                  className="h-full w-full object-contain"
                />
              </a>
            </div>

            <p className="mt-14 text-center text-sm font-medium text-white lg:text-left">
              &copy; {currentYear} Warp Speed Mortgage
            </p>
          </div>

          <div className="flex-1">
            <div className="space-y-5 text-center lg:text-left">
              <p className="text-[0.95rem] font-semibold leading-[1.6] text-white md:text-[1rem]">
                Loans Provided by Warp Speed Mortgage, a dba of CalCon Mutual Mortgage LLC. Warp Speed Mortgage is an
                Equal Housing Lender.
              </p>

              <p className="text-[0.95rem] font-semibold leading-[1.6] text-white md:text-[1rem]">
                NMLS #46375 (
                <a
                  className="underline transition-colors hover:text-green-primary"
                  href="https://www.nmlsconsumeraccess.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  www.nmlsconsumeraccess.org
                </a>
                ); 3838 Camino del Rio N Suite 305, San Diego, CA 92108. Corporate phone (877) 707-2050. For licensing
                information, go to:{" "}
                <a
                  className="underline transition-colors hover:text-green-primary"
                  href="https://www.nmlsconsumeraccess.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  www.nmlsconsumeraccess.org
                </a>
              </p>

              <p className="text-[0.95rem] font-semibold leading-[1.6] text-white md:text-[1rem]">
                &copy; 2013 - {currentYear} Warp Speed Mortgage
              </p>

              <p className="text-[0.95rem] font-semibold leading-[1.6] text-white md:text-[1rem]">
                By refinancing your existing loan, your total finance charges may be higher over the life of the loan.
                (Reference: 10 VAC 5-160-60 (F))
              </p>

              <p className="text-[0.95rem] font-semibold leading-[1.6] text-white md:text-[1rem]">
                All products are not available in all states. All options are not available on all programs. All
                programs are subject to borrower and property qualifications. Rates, terms and conditions are subject to
                change without notice.
              </p>

              <div className="pt-4">
                <div className="flex flex-wrap justify-center gap-x-2 gap-y-2 text-[0.95rem] font-semibold md:text-[1rem] lg:justify-start">
                  {footerLinks.map((link, index) => (
                    <React.Fragment key={link.label}>
                      <a
                        href={link.href}
                        target={link.external ? "_blank" : undefined}
                        rel={link.external ? "noreferrer" : undefined}
                        className="underline transition-colors hover:text-green-primary"
                      >
                        {link.label}
                      </a>
                      {index < footerLinks.length - 1 ? <span className="text-white/70">|</span> : null}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
